import {
  Button,
  Stack,
  Box,
  Slide,
  Slider,
  styled,
  CircularProgress,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

import { tease } from "../components/CheckButton";
import {
  Color,
  ErrorCode,
  FontStyle,
  MediaQuery,
  READY_EMPLOYER,
  VideoOrientation,
  navPaddingTop,
  matchesOnlySizing,
  jobPageSizing,
} from "../constants";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { StyledTextField } from "../components/AutocompleteUtils";
import * as apiService from "../service/ApiService";
import { useDispatch, useSelector } from "react-redux";
import ExpChip from "../components/ExpChip";
import ScrollJobs from "../components/JobPanels/ScrollJobs";
import JobDetails from "../components/JobPanels/JobDetails";
import JobFavToggle from "../components/JobPanels/JobFavToggle";
import { LoaderOrError } from "../utils/jobUtils";
import JobLoader from "../components/Virtual/JobLoader";
import { JobBg } from "../components/JobPanels/jobLayoutElements";
import ThirdColumnVideoAdWrapper from "../components/JobPanels/ThirdColumnVideoAdWrapper";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
  },
  colorContainer: {
    px: "24px",
    paddingTop: "24px",
    width: "100%",
  },
};
const sizingStyles = matchesOnlySizing;

// linkedin display modes:
// 0: mobile - 1 column, feed only < 768px
// 1: 2 column, < 992px
// 2: 3 column small, < 1200px
// 3: 3 column large, > 1200px

const MatchesOnly = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const loggedIn =
    auth.accountData.loginToken !== null &&
    auth.accountData.contactInfo !== null;
  const [email, setEmail] = useState("");
  const rowDisplay = useMediaQuery({ query: MediaQuery.md });
  const mobile0 = useMediaQuery({ query: MediaQuery.mobile0 });
  const desktop1 = useMediaQuery({ query: MediaQuery.desktop1 });
  const desktop2 = useMediaQuery({ query: MediaQuery.desktop2 });
  const [selectedIdx, setSelectedIdx] = React.useState(!mobile0 ? 0 : null); // index of selected job
  const screenSizing = mobile0 ? 0 : desktop1 ? 1 : desktop2 ? 2 : 3;
  const [showDescriptionOverlay, setShowDescriptionOverlay] = useState("");

  const [filterIdx, setFilterIdx] = React.useState(0); // index of filter
  const showThirdColumnVideoAd =
    READY_EMPLOYER &&
    screenSizing >= 2 &&
    auth.jobs &&
    selectedIdx !== null &&
    auth.jobs[selectedIdx].vidUrl &&
    auth.jobs[selectedIdx].vidSize === VideoOrientation.portrait;
  const setJobIdx = (job) => {
    const newIdx = auth.jobs.findIndex(
      (j) => j.url === job.url && j.jobId === job.jobId
    );
    setSelectedIdx(newIdx);
    // scroll smoothly if screen is not too far down
    // if (window.scrollY < window.innerHeight) {
    //   window.scrollTo({ top: 0, behavior: "smooth" });
    // } else {
    //   window.scrollTo({ top: 0 });
    // }
  };
  const parentName = `mf${screenSizing}`;
  if (auth.jobs === null)
    return (
      <Box sx={styles.outer}>
        <JobLoader />
        <Box
          sx={{
            ...FontStyle.body,
            textAlign: "center",
            px: 12,
            py: 4,
          }}>
          <LoaderOrError error={auth.error} />
        </Box>
      </Box>
    );

  return (
    <Stack sx={styles.outer} direction="column" alignItems="center">
      <JobBg />
      <Stack
        sx={styles.colorContainer}
        direction={mobile0 ? "column-reverse" : "row"}
        alignItems={mobile0 ? "center" : ""}
        justifyContent={mobile0 ? "" : "center"}
        spacing="24px">
        <Stack
          // left column
          sx={{
            width: sizingStyles[screenSizing].left,
            maxWidth: sizingStyles[screenSizing].maxWidth,
            minWidth:
              sizingStyles[screenSizing].left !== "100%"
                ? sizingStyles[screenSizing].left
                : "",
            // overflowY: 'scroll',
            // minHeight: '',
            // maxHeight: '100%',
            // height: '100%',
            // backgroundColor: 'blue',
          }}
          direction="column"
          spacing={2}
          alignItems="center">
          <JobFavToggle idx={filterIdx} setIdx={setFilterIdx} />
          <ScrollJobs
            jobs={auth.jobs}
            handleClick={setJobIdx}
            selectedJob={
              selectedIdx !== null && selectedIdx !== undefined
                ? auth.jobs[selectedIdx]
                : null
            }
            filterIdx={filterIdx}
            mobile={mobile0}
            showDescriptionOverlay={showDescriptionOverlay}
          />
        </Stack>
        {!mobile0 && (
          <Stack
            // middle column
            sx={{
              ...(showThirdColumnVideoAd
                ? {
                    width: jobPageSizing[screenSizing].mid,
                    maxWidth: jobPageSizing[screenSizing].maxWidth,
                  }
                : {
                    width: sizingStyles[screenSizing].mid,
                    maxWidth: sizingStyles[screenSizing].maxWidth,
                  }),
              minWidth: "",
              position: mobile0 ? "static" : "sticky",
              top: mobile0 ? "0px" : "12px",
              zIndex: mobile0 ? 0 : 1,
              alignSelf: mobile0 ? "" : "flex-start", // necessary for sticky in flexbox
            }}
            direction="column"
            spacing={2}
            alignItems="center">
            {auth.jobs && selectedIdx !== null && (
              <JobDetails
                job={auth.jobs[selectedIdx]}
                mobile={mobile0}
                focusMode
                useWindowHeight={!mobile0}
                showDescriptionOverlay={showDescriptionOverlay}
                parentName={parentName}
                showPortraitAd={screenSizing <= 1}
              />
            )}
          </Stack>
        )}
        {showThirdColumnVideoAd && (
          <Stack
            sx={{
              width: jobPageSizing[screenSizing].right,
              maxWidth: jobPageSizing[screenSizing].maxWidth,
            }}
            direction="column"
            spacing={2}
            alignItems="center">
            <ThirdColumnVideoAdWrapper
              auth={auth}
              selectedIdx={selectedIdx}
              mobile={mobile0}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default MatchesOnly;
